export default __webpack_public_path__ + "static/media/eqqqe.c5d32898.svg";